import { cn } from '@folio/lib';

export const InformationFieldCell = ({
  children,
  className,
  colSpan,
}: {
  children: React.ReactNode;
  className?: string;
  colSpan?: number;
}) => {
  return (
    <td
      colSpan={colSpan}
      className={cn(
        'overflow-hidden text-ellipsis py-2 min-w-0 [&:not(:first-child)]:pl-2 [&:not(:first-child)]:md:pl-4',
        className,
      )}
    >
      {children}
    </td>
  );
};
